module.exports = __webpack_public_path__ + "img/bx-arranging-pub-active.771b030e.svg";